/** AUTOGENERATED FILE - DO NOT MODIFY!!!!! */
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

import { CommunicationService } from '../communication/communication.service';
import { IClientOptions } from '../communication/interfaces/client-options.intefrace';
import { WebServiceResponseTyped } from '../models/ETG_SABENTISpro_Application_Core_models';
import { FrontendError } from '../models/ETG_SABENTISpro_Application_Core_models';

@Injectable({ providedIn: 'root' })
export class LogService
{
  constructor(public generalService: CommunicationService) {}

  /**
  *
  * Log a frontend-error
  *
  * @param {FrontendError} error
  * @param {IClientOptions} clientOpts is an Object that contains optional value to define parameters on the client side
  * @returns {any}
  */
  postError(error: FrontendError, clientOpts: IClientOptions = {showSpinner: true}): Observable<WebServiceResponseTyped<any>>
  {
    const params: any = {'error' : JSON.stringify(error)};
    return this.generalService.post('core-log/error', params, clientOpts) as Observable<WebServiceResponseTyped<any>>;
  }
}
